// Decides when a rewarded ad falls back to the Game8 house banner (#137). Pure
// so it can be unit-tested; AdInstance wires it to the AdSense flow.

// Every ad reaches the player through AdSense alone, and AdSense declines far
// more breaks than it fills. These are the outcomes where no ad was ever there
// to watch: the player asked for a reward and got nothing back.
//
// `dismissed` and `ignored` are left out on purpose. An ad was offered or shown
// and the player walked away from it — rewarding those would pay out for
// skipping the ad.
export const NO_FILL_STATUSES = [
  'frequencyCapped',
  'notReady',
  'noAdPreloaded',
  'timeout',
  'error',
  'invalid',
  'other',
];

export function isNoFill(breakStatus) {
  return NO_FILL_STATUSES.indexOf(breakStatus) !== -1;
}

const DEFAULT_SECONDS = 5;
// A number typed wrong in the API config must not hold a player behind a
// static banner for a minute.
const MAX_SECONDS = 30;

// The API already serves `promo.rainbow` in gameData — `enabled`, which
// placements it covers, and `duration` — so the fallback is switched per game
// from there without a plugin release.
export function resolveRewardFallback(gameData) {
  const rainbow = gameData && gameData.promo && gameData.promo.rainbow;
  const enabled = !!(
    rainbow &&
    rainbow.enabled === true &&
    rainbow.position &&
    rainbow.position.rewarded === true
  );

  let seconds = Number(rainbow && rainbow.duration);
  if (!Number.isFinite(seconds) || seconds <= 0) seconds = DEFAULT_SECONDS;
  seconds = Math.min(Math.round(seconds) || 1, MAX_SECONDS);

  return { enabled, seconds };
}
